import axios from 'axios';

const baseURL = 'https://smart-cars-api.onrender.com';

const axiosInstance = axios.create({
    baseURL: baseURL
});

export default axiosInstance;
